// 缅甸语(缅甸)
export default {
  el: {
    select: {
      loading: 'တင်သော',
      noMatch: 'ကိုက်ညီသောဒေတာမရှိပါ',
      noData: 'ဒေတာမရှိပါ',
      placeholder: 'ကျေးဇူးပြု၍ ရွေးချယ်ပါ',
    },
  },
  layout: {
    title: 'Uniportal ID ျဖင့္ လက္မွတ္ထိုးဝင္ျခင္း',
    tip: 'မှတ်ပုံတင်ထားခြင်းမရှိသောမိုဘိုင်းနံပါတ်များကိုအောင်မြင်သော login ပြီးနောက်အလိုအလျောက်မှတ်ပုံတင်သည်။.',
    line: 'အျခား ဝင္ေရာက္ရန္ ေရြးခ်ယ္စရာမ်ား',
  },
  button: {
    submit: 'ဝင်ရန် / မှတ်ပုံတင်ရန်',
    getCode: 'ကုဒ္ ရယူရန္',
    emailRegister: 'အီးေမးလ္ျဖင့္ စာရင္းသြင္းရန္',
    w3Login: 'W3 အကောင့်ဝင်မည်',
    employeeLogin: 'ဝန်ထမ်းဝင်မည်',
    passwordLogin: 'စကားဝွက္ျဖင့္ ဝင္ေရာက္ရန္',
    reSend: 'ပန္ပို႔ရန္',
    problem: 'ပြproblemsနာများကြုံတွေ့ရသည်',
    privacyPolicy: 'ကိုယ်ရေးအချက်အလက်မူဝါဒ',
  },
  placeholder: {
    phoneNumber: 'မိုဘိုင္းနံပါတ္',
    verificationCode: 'SMS အတည္ျပဳ ကုဒ္',
  },
  dialog: {
    imgCode: '႐ုပ္ပုံေပၚရွိ အကၡရာမ်ားကို ႐ိုက္ထည့္ပါ။',
    userAgreements: {
      header: 'သုံးစြဲသူ သေဘာတူညီခ်က္ႏွင့္ ကိုယ္ေရးအခ်က္အလက္ လုံျခံဳေရး ထုတ္ျပန္ခ်က္',
      text1: '{privacy} ႏွင့္ {agreement} ကို ဖတ္ရႈၿပီး သေဘာတူေပးပါ။',
      text2:
        'တရုတ်နိုင်ငံပြင်ပရှိ Huawei application များကိုအသုံးပြုသောအခါကိုယ်ရေးကိုယ်တာအချက်အလက်များကိုတရုတ်နိုင်ငံပြင်ပရှိ Huawei လက်အောက်ခံများသို့လွှဲပြောင်းပေးလိမ့်မည်။ အသေးစိတ်အတွက် {privacy} တွင်ကြည့်ပါ။.',
    },
    crossBorder: {
      header: 'ခွင့်ပြုချက်သိကောင်းစရာများ',
      text: 'သင်အသုံးပြုသောဒေသခံ ၀ န်ဆောင်မှုသည်သင်၏အကောင့်ကိုမှတ်ပုံတင်သည့်နေရာနှင့်မတူပါ။. အကောင့်အချက်အလက်များကိုနယ်စပ်ဖြတ်ကျော်ဝင်ရောက်ခြင်းပါ ၀ င်ပါကသင်၏ခွင့်ပြုချက်ကိုသင်ရယူရမည်။.',
    },
    multiAccounts: 'အေကာင့္တစ္ခုကို ေ႐ြးခ်ယ္ပါ။',
    agreeButton: 'သေဘာတူၿပီး ဆက္လုပ္မည္',
    disagreeButton: 'သေဘာမတူပါ',
    confirmButton: 'အတည်ပြုခဲ့သည်',
    cancelButton: 'ပယ်ဖျက်ရန်',
    knowMe: 'ငါသိတယ်။.',
  },
  toast: {
    hasSend: 'အတည္ျပဳ ကုဒ္ ပို႔လိုက္ပါၿပီ။',
    wait: 'ခဏလောက် ကျေးဇူးပြုပြီး။.',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'CAPTCHA ကုဒ္ကို အလြတ္ထား၍ မရပါ။',
    'IDC-03-0002': 'CAPTCHA ကုဒ္ သက္တမ္းကုန္သြားပါၿပီ။',
    'IDC-00-0004': 'CAPTCHA ကုဒ္ မမွန္ကန္ပါ။',

    // 表单输入为空
    'IDC-01-00024': 'သင့္မိုဘိုင္းနံပါတ္ကို အတည္ျပဳရန္ ႏိုင္ငံကုဒ္ လိုအပ္ပါသည္။',
    phoneNumberEmpty: 'မိုဘိုင္းနံပါတ္ ႐ိုက္ထည့္ပါ။',
    'IDC-03-00033': 'SMS အတည္ျပဳ ကုဒ္ ရိုက္ထည့္ပါ။',

    // 表单数据错误
    'IDC-02-00227': 'ထည့်သွင်းထားသောမိုဘိုင်းနံပါတ်သည်ရွေးချယ်ထားသောနိုင်ငံ / ဒေသနှင့်မကိုက်ညီပါ',
    'IDC-02-00226': 'တိုင်းပြည်ကုဒ်ကိုပိတ်ထားသည်.',
    'IDC-02-00029': 'အတည်ပြုကုဒ်သည်မမှန်ကန်ပါသို့မဟုတ်သက်တမ်းကုန်သွားပြီဖြစ်သည်။.',
    'IDC-02-0013': 'SMS အကောင့်ဝင်ခြင်း မအောင်မြင်ပါ၊ အတည်ပြုကုဒ် အမှားအယွင်း.',
    'IDC-02-0020': 'အတည္ျပဳမႈ မေအာင္ျမင္ပါ။ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။',
    'IDC-02-00028': 'မိုဘိုင်းနံပါတ်သည်စာလုံး ၆ မှ ၃၀ အထိဖြစ်ရမည်။.',
    'IDC-02-00012': 'မိုဘိုင်းနံပါတ်မမှန်ပါ။.',

    // 错误操作锁定
    accountLock:
      'မိုဘိုင္းနံပါတ္ သို႔မဟုတ္ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။ ႀကိဳးပမ္းမႈ {number} ႀကိမ္ က်န္ပါသည္။ | မိုဘိုင္းနံပါတ္ သို႔မဟုတ္ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။ ႀကိဳးပမ္းမႈ {number} ႀကိမ္ က်န္ပါသည္။ | မိုဘိုင္းနံပါတ္ သို႔မဟုတ္ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။ ႀကိဳးပမ္းမႈ {number} ႀကိမ္ က်န္ပါသည္။ | မိုဘိုင္းနံပါတ္ သို႔မဟုတ္ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။ ႀကိဳးပမ္းမႈ {number} ႀကိမ္ က်န္ပါသည္။ | မိုဘိုင္းနံပါတ္ သို႔မဟုတ္ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။ ႀကိဳးပမ္းမႈ {number} ႀကိမ္ က်န္ပါသည္။ | မိုဘိုင္းနံပါတ္ သို႔မဟုတ္ အတည္ျပဳ ကုဒ္ မမွန္ကန္ပါ။ ႀကိဳးပမ္းမႈ {number} ႀကိမ္ က်န္ပါသည္။',
    accountLocked:
      'မေအာင္ျမင္သည့္ ႀကိဳးပမ္းမႈအေရအတြက္ မ်ားလြန္းေနပါသည္။ {number} စကၠန္႔အၾကာတြင္ ထပ္ႀကိဳးစားေပးပါ။ | မေအာင္ျမင္သည့္ ႀကိဳးပမ္းမႈအေရအတြက္ မ်ားလြန္းေနပါသည္။ {number} စကၠန္႔အၾကာတြင္ ထပ္ႀကိဳးစားေပးပါ။ | မေအာင္ျမင္သည့္ ႀကိဳးပမ္းမႈအေရအတြက္ မ်ားလြန္းေနပါသည္။ {number} စကၠန္႔အၾကာတြင္ ထပ္ႀကိဳးစားေပးပါ။ | မေအာင္ျမင္သည့္ ႀကိဳးပမ္းမႈအေရအတြက္ မ်ားလြန္းေနပါသည္။ {number} စကၠန္႔အၾကာတြင္ ထပ္ႀကိဳးစားေပးပါ။ | မေအာင္ျမင္သည့္ ႀကိဳးပမ္းမႈအေရအတြက္ မ်ားလြန္းေနပါသည္။ {number} စကၠန္႔အၾကာတြင္ ထပ္ႀကိဳးစားေပးပါ။ | မေအာင္ျမင္သည့္ ႀကိဳးပမ္းမႈအေရအတြက္ မ်ားလြန္းေနပါသည္။ {number} စကၠန္႔အၾကာတြင္ ထပ္ႀကိဳးစားေပးပါ။',
    operationRisk:
      'လက်ရှိစစ်ဆင်ရေးသည်လုံခြုံရေးအန္တရာယ်များရှိသည်။ ကျေးဇူးပြု၍ {number} စက္ကန့်အတွင်းထပ်မံကြိုးစားပါ။.',

    // 频繁操作
    'IDC-02-00038': 'စကၠန္႔ 60 ၾကာမွ ထပ္မံ ႀကိဳးစားပါ။',
    'IDC-02-00064':
      'သင်သည် SMS အတည်ပြုကုဒ်များကိုမကြာခဏပို့သည်။ ကျေးဇူးပြု၍ ၂၄ နာရီအကြာတွင်ထပ်မံကြိုးစားကြည့်ပါ။.',
    'IDC-02-00211':
      'လက်ရှိစစ်ဆင်ရေးသည်လုံခြုံရေးအန္တရာယ်များရှိသည်။ ကျေးဇူးပြုပြီးနောက်မှထပ်ကြိုးစားပါ.',
    'IDC-02-00212':
      'သင်၏မိုဘိုင်းနံပါတ်မှပေးပို့သော SMS အတည်ပြုကုဒ်အရေအတွက်မှာမကြာခဏဖြစ်သည်။ သင်၏မိုဘိုင်းနံပါတ်ကိုပြောင်းပါသို့မဟုတ် ၂၄ နာရီအကြာတွင်ထပ်မံကြိုးစားပါ။.',
    'IDC-02-00213':
      'သင်သည် SMS အတည်ပြုကုဒ်များကိုမကြာခဏပို့သည်။ ကျေးဇူးပြု၍ ၂၄ နာရီအကြာတွင်ထပ်မံကြိုးစားကြည့်ပါ။.',
    'IDC-02-00215':
      'သင်၏မိုဘိုင်းနံပါတ်မှပေးပို့သော SMS အတည်ပြုကုဒ်အရေအတွက်မှာမကြာခဏဖြစ်သည်။ ကျေးဇူးပြု၍ မိုဘိုင်းနံပါတ်ကိုပြောင်းလဲခြင်းသို့မဟုတ်အခြားအတည်ပြုနည်းကိုရွေးချယ်ရန်ကြိုးစားပါ၊ သို့မဟုတ် ၂၄ နာရီအကြာတွင်ထပ်မံကြိုးစားပါ။.',
    'IDC-02-00228':
      'သင်သည် SMS အတည်ပြုကုဒ်ကိုမကြာခဏပို့သည်။ ကျေးဇူးပြုပြီးတစ်နာရီအကြာမှာထပ်ကြိုးစားကြည့်ပါ.',
    'IDC-02-00092':
      'လက်ရှိစစ်ဆင်ရေးသည်အလွန်မကြာခဏဖြစ်သည်။ ကျေးဇူးပြု၍ ၂၄ နာရီအကြာတွင်ထပ်မံကြိုးစားကြည့်ပါ။.',

    // 请求异常
    'IDC-10-00400': 'ဖောက်သည်တောင်းဆိုမှုကိုချွင်းချက် ',
    'IDC-10-00500': 'ပြည်တွင်းစနစ်အမှား ',
    'IDC-02-00264': '၀ င်ရောက်မှုအတွက်ခွင့်ပြုချက်မရှိဘဲတောင်းဆိုမှုများကိုတားမြစ်ထားသည်',
    'IDC-02-00063': 'တရားမဝင် ကန့်သတ်ချက်.',
    'IDC-03-0007': 'လက်ရှိစစ်ဆင်ရေးသည်လုံခြုံရေးအန္တရာယ်များရှိပြီးမှတ်ပုံတင်။ မရပါ။.', // 机翻
    'IDC-03-00057': 'လက်ရှိစစ်ဆင်ရေးသည်လုံခြုံရေးအန္တရာယ်များရှိသည်။.',

    // 页面过期
    'IDC-00-00017': 'စာမ်က္ႏွာ သက္တမ္းကုန္သြားသည္။',
  },

  // 注册协议、隐私声明对话框
  backButton: 'ေနာက္သို႔',
  closeButton: 'ပိတ္မည္',

  // 滑块验证相关：
  resourceReqFailed:
    'အရင်းအမြစ်တောင်းဆိုမှုမအောင်မြင်ပါ စာမျက်နှာကိုပြန်လည်မွမ်းမံပြီးထပ်မံကြိုးစားပါ။.',
  verifyFailedAndPlsRetry: 'အတည်ပြုမှုမအောင်မြင်ပါ ကျေးဇူးပြုပြီးထပ်ကြိုးစားပါ.',
  serviceErrAndPlsRetry: 'ဝန်ဆောင်မှုခြွင်းချက်။ ကျေးဇူးပြုပြီးထပ်ကြိုးစားပါ.',
  learnMore: 'ပိုမိုသိရှိရန်',
  cookieBannerText: 'ဤဝက်ဘ်ဆိုက်သည်သင့်အားအကောင်းဆုံးအသုံးပြုသူအတွေ့အကြုံပေးရန် cookies ကိုအသုံးပြုသည်။.',
};
